export default __webpack_public_path__ + "static/media/checkbox-checked.abb1a421.svg";